import { IApplicationState } from '../../../../types/types';
import { getAuthUser } from './getAuthUser';
import { EProductPack } from '../../../../view/react_components/dialogs/price_page/types';
import { getProductById } from 'app/store/model/authUser/selectors/getProductById';

export const getIsUserEssentialPlanOnly = (
    state: IApplicationState
): boolean => {
    const user = getAuthUser(state);
    let isEssentialPlan = false;
    const subscriptions = user.activeSubscription;
    let i = subscriptions.length;
    while (i--) {
        const { productId } = subscriptions[i];
        if (getProductById(productId).pack.id === EProductPack.ESSENTIAL) {
            isEssentialPlan = true;
        } else if (
            getProductById(productId).pack.id === EProductPack.PREMIUM ||
            getProductById(productId).pack.id === EProductPack.PROFESSIONAL ||
            getProductById(productId).pack.id === EProductPack.ENTERPRISE
        ) {
            isEssentialPlan = false;
            break;
        }
    }
    return isEssentialPlan;
};
